import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import CircularLoader from "../../utils/Loaders/CircularLoader";
import iconDelete from "../../assets/images/delete.svg";
import { reportListUrl, submitReportUrl } from "../../Routes/ApiRoutes.js";
import { Post, Get } from "../../Api/ApiMethods";
import { toast } from "react-toastify";
import AWS from "aws-sdk";
import { uploadFile } from "react-s3";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  useHistory,
} from "react-router-dom";
import Arrow from "../../assets/images/arrow.svg";

import selectArrow from "../../assets/images/selectArrow.svg";

export default function ReportIssue() {
  const token = useSelector((state) => state.auth.isSignedIn);
  const [loader, setLoader] = useState(false);
  const [reportList, setReportList] = useState([]);
  const config = {
    bucketName: process.env.React_App_S3_bucketName,
    dirName: "",
    region: process.env.React_App_S3_Region,
    accessKeyId: process.env.React_App_S3_AccessKeyId,
    secretAccessKey: process.env.React_App_S3_SecretAccessKey,
    s3Url: process.env.React_App_S3_Url,
  };
  const [data, setData] = useState({
    category_id: 0,
    message: "",
    attachments: [],
  });
  const [key, setKey] = useState([]);
  const [reportTypeError, setReportTypeError] = useState(null);
  const [addMsgError, setAddMsgError] = useState(null);

  useEffect(() => {
    fetchReportList();
  }, []);
  const fetchReportList = () => {
    setLoader(true);
    try {
      Get(reportListUrl, token)
        .then((res) => {
          if (res.status === 200) {
            setReportList(res.data);
            setLoader(false);
          }
        })
        .catch((error) => {
          toast.error(error.error);
          setLoader(false);
        });
    } catch (error) {
      toast.error(error.error);
      setLoader(false);
    }
  };
  const handleReportTypeChange = (e) => {
    let updatedDetails = { ...data };
    updatedDetails[e.target.id] = e.target.value;
    setData(updatedDetails);
    if (e.target.value === "0") {
      setReportTypeError("Report type is mandatory.");
    } else {
      setReportTypeError(null);
    }
  };

  const history = useHistory();

  const handleAdMsgChange = (e) => {
    let updatedDetails = { ...data };
    updatedDetails[e.target.id] = e.target.value;
    setData(updatedDetails);
    if (e.target.value === "") {
      setAddMsgError("Additional message is mandatory.");
    } else if (e.target.value.length > 200) {
      setAddMsgError("Max length is 200 character.");
    } else {
      setAddMsgError(null);
    }
  };

  const handleImageChange = (e) => {
    if (e.target.files) {
      var img = e.target.files;
      for (let i = 0; i < img.length; i++) {
        let imageArray = img[i].name.split(".");
        if (imageArray.length > 2 && imageArray.length < 2) {
          toast.error("Double extension files are not allowed.");
          setLoader(false);
        }
        // else if(imageArray[1] !== "jpeg" && imageArray[1] !== "jpg" && imageArray[1] !== "png" )
        // {
        //     setLoader(false);
        // 	toast.error("Only jpeg, jpg or png images are allowed.");
        // }
        else if (img[i].size > 5242880) {
          setLoader(false);
          toast.error("Max size should be less than 5MB.");
        } else {
          for (let j = 0; j < key.length; j++) {
            if (key[j].key === img[i].name) {
              toast.error("Image with same name already exist.");
              return;
            }
          }
          setLoader(true);
          let fl = img[i];
          uploadFile(fl, config)
            .then((d) => {
              let kk = key;
              let k = {
                key: d.key,
                location: d.location,
                type: d.key.split(".")[1].toString().toLowerCase(),
              };
              kk.push(k);
              setKey(kk);

              let updatedDetails = { ...data };
              let url = updatedDetails["attachments"];
              let ur = d.location;
              url.push(ur);
              setData(updatedDetails);
              setLoader(false);
            })
            .catch((err) => {
              toast.error(err.message);
              setLoader(false);
              e.target.value = "";
            });
        }
      }
      e.target.value = "";
    } else {
      toast.error("Please select an image.");
      setLoader(false);
      e.target.value = "";
    }
  };

  const deleteS3Object = async (key) => {
    return new Promise((resolve, reject) => {
      try {
        let s3bucket = new AWS.S3({
          dirName: "",
          accessKeyId: process.env.React_App_S3_AccessKeyId,
          secretAccessKey: process.env.React_App_S3_SecretAccessKey,
          Bucket: process.env.React_App_S3_bucketName,
        });
        var params = { Bucket: process.env.React_App_S3_bucketName, Key: key };
        s3bucket.deleteObject(params, function (err, data) {
          if (err) reject(err); // an error occurred
          else resolve(data); // successful response
        });
      } catch (e) {
        reject(e);
      }
    });
  };

  const handleDeleteImage = (val) => {
    setLoader(true);
    try {
      deleteS3Object(val.key)
        .then((response) => {
          let vl = key;
          let index = vl.findIndex((obj) => obj.key === val.key);
          vl.splice(index, 1);
          setKey(vl);

          let updatedDetails = { ...data };
          let url = updatedDetails["attachments"];
          let ind = url.findIndex((obj) => obj.key === val.key);
          url.splice(ind, 1);
          setData(updatedDetails);

          setLoader(false);
          toast.error("File removed.");
        })
        .catch((error) => {
          setLoader(false);
          toast.error("Something went wrong. Please try again later.");
          toast.error(error.error);
        });
    } catch (error) {
      setLoader(false);
      toast.error("Something went wrong. Please try again later.");
      console.log(error);
    }
  };

  const handleSubmit = () => {
    setLoader(true);
    try {
      Post(submitReportUrl, token, data)
        .then((res) => {
          if (res.status === 200) {
            setLoader(false);
            setData({
              category_id: 0,
              message: "",
              attachments: [],
            });
            setKey([]);
            toast.success(res.message);
          }
        })
        .catch((error) => {
          toast.error(error.error);
          setLoader(false);
        });
    } catch (error) {
      toast.error(error.error);
      setLoader(false);
    }
  };

  return (
    <section className="Report-issue-wrapper">
      {loader && <CircularLoader />}
      <div className="container">
        <div className="Report-issue">
          <div className="row no-gutters">
            <div className="col-md-8 col-sm-12 col-12 padding-rt">
              <div className="generate">
                <div className="row comman-btn ">
                  <h3>
                    {" "}
                    <img onClick={history.goBack} src={Arrow} />
                  </h3>
                  <h3>Report issue</h3>
                </div>
                <div className="form-group">
                  <label>Select issue</label>
                  {/* <img className='selectImage' src={selectArrow} onClick={()=>{
                                    var x = document.getElementById('category_id')
                                    x.click();
                                }} /> */}
                  <select
                    className={
                      reportTypeError
                        ? "form-control borderRed"
                        : "form-control"
                    }
                    onChange={handleReportTypeChange}
                    id="category_id"
                    value={data.category_id}
                  >
                    <option value="0">Select</option>
                    {reportList &&
                      reportList.map((item) => (
                        <option key={item.category_id} value={item.category_id}>
                          {item.category_name}
                        </option>
                      ))}
                  </select>
                  {reportTypeError && (
                    <span className="form-error">{reportTypeError}</span>
                  )}
                </div>
                <div className="form-group">
                  <label>Additional message</label>
                  <input
                    onChange={handleAdMsgChange}
                    className={
                      addMsgError ? "form-control borderRed" : "form-control"
                    }
                    placeholder="Write here"
                    id="message"
                    type="text"
                    value={data.message}
                  />
                  {addMsgError && (
                    <span className="form-error">{addMsgError}</span>
                  )}
                </div>

                {key.length > 0 &&
                  key.map((it) => {
                    return (
                      <div key={it.location} className="previewImage dis-b">
                        <span>
                          <img
                            onClick={() => handleDeleteImage(it)}
                            className="deleIcon"
                            src={iconDelete}
                          />
                        </span>
                        {it.type === "pdf" ? (
                          <a target="_blank" href={it.location}>
                            <iframe src={it.location} />
                          </a>
                        ) : it.type === "jpeg" ||
                          it.type === "jpg" ||
                          it.type === "png" ||
                          it.type === "gif" ? (
                          <a target="_blank" href={it.location}>
                            <img src={it.location} alt={it.key} />
                          </a>
                        ) : (
                          <a
                            className="link"
                            target="_blank"
                            href={it.location}
                          >
                            {it.key}
                          </a>
                        )}
                      </div>
                    );
                  })}
                <div className="Upload-attachment">
                  <div className="upload">
                    <div className="Uploadtext">Upload attachment</div>
                    <div
                      onClick={() =>
                        document.getElementById("attachments").click()
                      }
                      className="UploadIcon"
                    >
                      +
                      <input
                        onChange={handleImageChange}
                        id="attachments"
                        type="file"
                        multiple
                      />
                    </div>
                  </div>
                </div>
                <div className=" comman-btn form-group">
                  <button onClick={handleSubmit}>Send report</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
